import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import { useLocation } from 'react-router-dom';

import {
  PageSubTitle,
  PaginationGroup,
  EmptyState,
  Loading,
  LinkBack
} from 'components/common/Elements/Elements';
import MainInfo from './PlatformApplicationsInfo/PlatformApplicationsInfo';
import PlatformApplication from './PlatformApplication/PlatformApplication';

import { postRequest } from 'utils/requests';
import { initialTableShow } from 'utils/settings';
import { getPaginateList } from './helpers/helpers';

import classes from './PlatformApplications.module.scss';

const PlatformApplications = ({ customerId }) => {
  const location = useLocation();
  const appId = location.state ? location.state.appId : '';

  const [loader, setLoader] = useState(true);
  const [loaderJson, setLoaderJson] = useState(true);
  const [appsData, setAppsData] = useState([]);
  const [applicationsList, setApplicationsList] = useState([]);
  const [idOpenDataApp, setIdOpenDataApp] = useState(appId);
  const [jsonDataApp, setJsonDataApp] = useState({});
  const [loaderTable, setLoaderTable] = useState(true);
  const [currentPage, setCurrentPage] = useState(initialTableShow.currentPage);
  const [findPageCurrentID, setFindPageCurrentID] = useState(appId);

  const itemsPerPage = initialTableShow.itemsPerPage;

  const { t } = useTranslation(['activity']);

  useEffect(() => {
    getApplications();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (appsData.length > 0) {
      setLoaderTable(true);
      let pageForCurrentId = '';
      if (findPageCurrentID) {
        const index = appsData.findIndex(el => el.appId === findPageCurrentID);
        pageForCurrentId = Math.trunc(index / 25 + 1);
        if (index) {
          setCurrentPage(pageForCurrentId);
        }
      }
      setApplicationsList(
        getPaginateList(
          appsData,
          pageForCurrentId ? pageForCurrentId : currentPage,
          itemsPerPage
        )
      );
      if (findPageCurrentID) {
        setFindPageCurrentID('');
      }
      setLoaderTable(false);
      setLoader(false);
    }
    // eslint-disable-next-line
  }, [appsData, customerId, currentPage, itemsPerPage]);

  useEffect(() => {
    let cancelled = false;
    if (idOpenDataApp !== '') {
      const REQ_BODY = {
        appId: idOpenDataApp
      };
      postRequest('/customer/platform/application/info', REQ_BODY)
        .then(res => {
          if (!cancelled) {
            setLoaderJson(true);
            setJsonDataApp(res.body);
            setLoaderJson(false);
          }
        })
        .catch(err => {
          if (!cancelled) {
            console.log(err);
            setLoaderJson(false);
          }
        });
    }
    return () => (cancelled = true);
  }, [idOpenDataApp]);

  const getApplications = () => {
    let cancelled = false;
    const REQ_BODY = {
      customerId: customerId
    };
    const url = `/customer/platform/applications/list`;
    postRequest(url, REQ_BODY)
      .then(res => {
        if (!cancelled) {
          setAppsData(res.body);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setLoader(false);
          setLoaderTable(false);
          console.log(err);
        }
      });
    return () => (cancelled = true);
  };

  const handleOpenAPP = _id => {
    setLoaderJson(true);
    _id !== idOpenDataApp ? setIdOpenDataApp(_id) : setIdOpenDataApp('');
  };

  if (loader) {
    return <Loading />;
  }

  const appsList = () => {
    if (applicationsList.data && applicationsList.data.length > 0) {
      return (
        <>
          {loaderTable ? (
            <Loading />
          ) : (
            applicationsList.data.map(app => {
              return (
                <div className={classes.box} key={app.appId}>
                  <div className={classes.boxBody}>
                    <PlatformApplication app={app} />
                    <MainInfo
                      app={app}
                      handleOpenAPP={handleOpenAPP}
                      idOpenDataApp={idOpenDataApp}
                    />
                  </div>
                  {idOpenDataApp === app.appId && (
                    <div className={classes.jsonInfoWraper}>
                      {loaderJson ? (
                        <Loading />
                      ) : jsonDataApp && typeof jsonDataApp === 'object' ? (
                        <ReactJson
                          src={jsonDataApp}
                          iconStyle="triangle"
                          enableClipboard={false}
                          displayDataTypes={false}
                          displayObjectSize={false}
                          indentWidth={4}
                          collapsed={false}
                        />
                      ) : (
                        <p>{jsonDataApp}</p>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          )}
          {applicationsList.data && applicationsList.totalPages > 1 ? (
            <PaginationGroup
              pageCount={applicationsList.totalPages}
              setPage={setCurrentPage}
              currentPage={currentPage}
              itemsTotal={applicationsList.size}
              itemsPerPage={itemsPerPage}
            />
          ) : null}
        </>
      );
    } else {
      return <EmptyState message="connect" />;
    }
  };

  return (
    <div className={classes.applications}>
      <div className={classes.header}>
        <PageSubTitle title={t('activity:platform.APPLICATIONS')} />
        <LinkBack text="Platform" />
      </div>
      {appsList()}
    </div>
  );
};

PlatformApplications.propTypes = {
  customerId: PropTypes.string
};

export default PlatformApplications;
